var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvisoAzul({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37125 13.649H13.6895V12.25H6.37125V13.649ZM6.37125 10.6895H17.6287V9.29051H6.37125V10.6895ZM6.37125 7.72976H17.6287V6.33076H6.37125V7.72976ZM2.702 20.7355V4.38801C2.702 3.91435 2.86791 3.5116 3.19975 3.17976C3.53175 2.84776 3.934 2.68176 4.4065 2.68176H19.5935C20.066 2.68176 20.4682 2.84776 20.8002 3.17976C21.1321 3.5116 21.298 3.91385 21.298 4.38651V15.6135C21.298 16.0862 21.1321 16.4884 20.8002 16.8203C20.4682 17.1523 20.066 17.3183 19.5935 17.3183H6.11925L2.702 20.7355ZM5.53375 15.9193H19.5912C19.6682 15.9193 19.7388 15.8872 19.803 15.823C19.867 15.759 19.899 15.6885 19.899 15.6115V4.38851C19.899 4.31151 19.867 4.24101 19.803 4.17701C19.7388 4.11285 19.6682 4.08076 19.5912 4.08076H4.40875C4.33175 4.08076 4.26116 4.11285 4.197 4.17701C4.133 4.24101 4.101 4.31151 4.101 4.38851V17.3443L5.53375 15.9193Z",
    fill: "#00BDD9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvisoAzul);
export default __webpack_public_path__ + "static/media/aviso_azul.44d7cde8ddd09a6108b720aa67181ee7.svg";
export { ForwardRef as ReactComponent };